exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-select[data-v-a61afd1e] {\n  display: block;\n}\n", ""]);

// exports
